import { useState } from "react";
import Constants from "../Constants";
import useAxios from "./useAxios";
import { useConfirm } from "../contexts/ConfirmContext";

const useCaseListTable = ({ getCases } = {}) => {
    const [openCaseId, setOpenCaseId] = useState(null);
    const { deleteData } = useAxios();
    const confirm = useConfirm();

    const handleToggle = (caseId) => {
        setOpenCaseId(prev => prev === caseId ? null : caseId);
    };

    const handleCloseBox = () => {
        setOpenCaseId(null);
    };

    const handleDelete = async (caseId) => {
        if (!caseId) return;
        const ok = await confirm({
            title: "Delete this case?",
            confirmText: "Delete",
            cancelText: "Cancel",
        });
        if (!ok) return;
        await deleteData(`${Constants.ApiUrl.case.deleteCase}/${caseId}`);
        getCases?.();
    };

    return {
        openCaseId,
        handleToggle,
        handleCloseBox,
        handleDelete,
    };
};

export default useCaseListTable;
